import { Component, DataSource, DataSourceRemoteDataChangeEvent, PanelProps, Tab } from "@mcleod/components";
import { AutogenLayoutInvoiceProcessingMultiProfile } from "./autogen/AutogenLayoutInvoiceProcessingMultiProfile";
import { LMEUserSettings } from "@mcleod/general";
import { MultiProfilePlanningTabs } from "@mcleod/dispatch/src/planning/MultiProfilePlanningTabs";
import { LogManager } from "@mcleod/core";
import { UserLayoutProvider } from "@mcleod/common";
import { InvoiceProcessing } from "./InvoiceProcessing";

const log = LogManager.getLogger("lme.ar.InvoiceProcessingMultiProfile");

export class InvoiceProcessingMultiProfile extends AutogenLayoutInvoiceProcessingMultiProfile {
    private userProfiles: string[] = [];
    private multiProfileTabs: MultiProfilePlanningTabs;

    async onLoad(): Promise<void> {
        const userSettings = LMEUserSettings.get();
        if (userSettings?.invoice_processing_profile != null)
            this.userProfiles.push(userSettings.invoice_processing_profile);
        if (userSettings?.invoice_processing_profile2 != null)
            this.userProfiles.push(userSettings.invoice_processing_profile2);
        if (userSettings?.invoice_processing_profile3 != null)
            this.userProfiles.push(userSettings.invoice_processing_profile3);
        if (userSettings?.invoice_processing_profile4 != null)
            this.userProfiles.push(userSettings.invoice_processing_profile4);

        try {
            this.multiProfileTabs = new MultiProfilePlanningTabs({
                tabset: this.tabsetInvoiceProcessingProfiles,
                profileDataSource: this.sourceInvoiceProcessingProfile,
                mainLayoutName: "lme/ar/InvoiceProcessing",
                advancedFilterLayout: "lme/ar/InvoiceProcessingProfileFilter",
                startingProfiles: this.userProfiles,
                profileDescrFieldName: "title",
                dataSourceToAddListener: this.sourceInvoiceProcessingCache,
                userSettingsCallback: () => {
                    log.debug("Profile change detected");
                    UserLayoutProvider.navigateTo();
                }
            });
        } catch (error) {
            log.error("Error initializing multi-profile tabs:", error);
            // Could fall back to single-profile mode or show an error message
        }
    }

    handleRemoteDataChange(event: DataSourceRemoteDataChangeEvent) {
        event.preventDefault();
        this.tabsetInvoiceProcessingProfiles.components.forEach((component: Component) => {
            const tab = component as Tab;
            tab.components.forEach((component: Component) => {
                if (component instanceof InvoiceProcessing) {
                    if ("lme/ar/invoice-processing-cache" === (event.target as DataSource).url) {
                        const dataSource = component.sourceInvoiceProcessingCache;
                        dataSource.handleDataChange(event.change);
                    }
                }
            });
        });
    }

    // Override the main router's padding to get the vertical profile tabset to be flush with the edge of the screen
    getRouterProps(): Partial<PanelProps> {
        return { padding: 0 };
    }
}
